import React from 'react'
import { useLocation } from 'react-router-dom'

import { SandboxState, useSandboxStore } from '@frame/lib/stores/useSandboxStore'
import { routes } from '@frame/routes'

import { SandboxCreds } from './form'

export function SandboxCredentials() {
  const location = useLocation()
  const sandboxState = useSandboxStore((state) => state.state)
  const isSandboxMode = sandboxState === SandboxState.FORM && location.pathname.includes(routes.credentials)

  if (!isSandboxMode) return null

  return (
    <div className="fixed bottom-0 left-0 z-50 flex w-full flex-col space-y-2 bg-slate-400 p-3 text-center text-background">
      You are currently in Sandbox mode
      <p>
        <span className="font-medium text-secondary">username:</span> {SandboxCreds.username}
        <span className="ml-4 font-medium text-secondary">password:</span> {SandboxCreds.password}
      </p>
    </div>
  )
}
